/* PrimeKitchen: native modal accessibility and existing-tag commerce events. */
(() => {
  'use strict';
  const node = document.getElementById('pk-commerce-data');
  if (!node) return;
  let config; try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const pending = [];
  const permitted = () => !!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();
  const ready = () => permitted() && Array.isArray(window.dataLayer) &&
    !!document.querySelector('script[src*="googletagmanager.com/gtag/js?id=' + config.measurementId + '"]');
  const push = (name, params) => {
    if (!ready()) return false;
    const gtag = function () { window.dataLayer.push(arguments); };
    gtag('event', name, { send_to: config.measurementId, ...params });
    return true;
  };
  const emit = (name, params) => { if (!push(name, params)) pending.push([name, params]); };
  const flush = () => { if (ready()) while (pending.length) { const [n, p] = pending.shift(); push(n, p); } };
  const timer = setInterval(flush, 1000); setTimeout(() => clearInterval(timer), 60000);
  document.addEventListener('visitorConsentCollected', flush);
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) flush(); });
  }
  const item = p => ({ item_id: String(p.sku || p.variant_id || p.id), item_name: p.product_title || p.title,
    item_brand: p.vendor || '', item_variant: p.variant_title || '', price: Number(p.final_price ?? p.price) / 100, quantity: Number(p.quantity || 1) });
  if (config.pageType === 'product' && config.product) emit('view_item', { currency: config.currency, value: config.product.price, items: [config.product] });
  // Observe successful native cart responses, without changing the request or checkout path.
  const originalFetch = window.fetch;
  let latestCart = config.cart || null;
  const refreshCart = () => originalFetch.call(window, '/cart.js', {credentials:'same-origin'}).then(r => r.json()).then(cart => {latestCart = cart;}).catch(() => {});
  if (config.pageType === 'cart') refreshCart();
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const path = typeof args[0] === 'string' ? args[0] : args[0]?.url;
    if (response.ok && /\/cart\/add(?:\.js)?(?:\?|$)/.test(path || '')) {
      response.clone().json().then(p => { const rows = p.items || [p]; emit('add_to_cart', { currency: config.currency,
        value: rows.reduce((s, x) => s + item(x).price * item(x).quantity, 0), items: rows.map(item) }); refreshCart(); }).catch(() => {});
    }
    if (response.ok && /\/cart\/(?:change|update)(?:\.js)?(?:\?|$)/.test(path || '')) response.clone().json().then(cart => {latestCart=cart;}).catch(() => {});
    return response;
  };
  // Ella uses jQuery for some add flows; global ajaxSuccess runs only after successful responses.
  if (window.jQuery) window.jQuery(document).on('ajaxSuccess.pkCommerce', (_e, xhr, settings) => {
    if (/\/cart\/(?:change|update)(?:\.js)?(?:\?|$)/.test(settings.url || '')) {refreshCart();return;}
    if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(settings.url || '')) return;
    try { const p = xhr.responseJSON || JSON.parse(xhr.responseText); const rows = p.items || [p];
      emit('add_to_cart', {currency: config.currency, value: rows.reduce((s,x) => s + item(x).price * item(x).quantity,0), items:rows.map(item)}); refreshCart();
    } catch (_) {}
  });
  let checkoutSent = false;
  const checkout = (resume) => {
    if (checkoutSent || !ready()) return; checkoutSent = true;
    const send = cart => {
      push('begin_checkout', {currency:cart.currency,value:cart.total_price/100,items:cart.items.map(item),transport_type:'beacon',...(resume ? {event_callback:resume,event_timeout:300} : {})});
    };
    if (latestCart) send(latestCart);
    else originalFetch.call(window, '/cart.js', {credentials:'same-origin',keepalive:true}).then(r => r.json()).then(send).catch(() => { checkoutSent = false; });
  };
  document.addEventListener('click', e => {
    const target = e.target.closest('button,a,input');
    if (!target || target.disabled || target.classList.contains('button-disable')) return;
    if (target.id === 'cart-checkout' || target.id === 'cart-sidebar-checkout' || target.name === 'checkout' || /\/checkout(?:\?|$)/.test(target.getAttribute('href') || '') || target.matches('[data-cart-sidebar-checkout]')) checkout();
  }, true);
  let lastFocus = null, activeModal = null;
  const dialogs = ['#halo-quick-view-popup', '#halo-cart-sidebar'];
  const visible = el => !!el && el.getBoundingClientRect().width > 0 && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none';
  const updateModal = () => {
    const selector = document.body.classList.contains('cart-sidebar-show') ? '#halo-cart-sidebar' : document.body.classList.contains('quick-view-show') ? '#halo-quick-view-popup' : null;
    const current = selector ? document.querySelector(selector) : null;
    if (current && current !== activeModal) {
      lastFocus = document.activeElement; activeModal = current;
      current.setAttribute('role','dialog'); current.setAttribute('aria-modal','true');
      current.setAttribute('aria-label',current.id === 'halo-cart-sidebar' ? 'Shopping cart' : 'Product quick view');
      const close = current.querySelector('[data-close-quick-view-popup],[data-close-cart-sidebar]');
      if (close) { close.setAttribute('aria-label','Close'); close.focus({preventScroll:true}); }
    } else if (!current && activeModal) { activeModal = null; if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true}); }
  };
  const observer = new MutationObserver(updateModal); observer.observe(document.body,{attributes:true,attributeFilter:['class'],childList:true,subtree:true});
  document.addEventListener('keydown', e => {
    updateModal();
    if (!activeModal || !visible(activeModal)) return;
    if (e.key === 'Escape') { const close = activeModal.querySelector('[data-close-quick-view-popup],[data-close-cart-sidebar]'); if (close) {e.preventDefault();close.click();} }
    if (e.key === 'Tab') { const nodes = [...activeModal.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(el => visible(el) && !el.disabled);
      if (!nodes.length) return; const first=nodes[0], last=nodes[nodes.length-1];
      if (e.shiftKey && document.activeElement === first) {e.preventDefault();last.focus();} else if (!e.shiftKey && document.activeElement === last) {e.preventDefault();first.focus();} }
  });
})();
